module.exports = __webpack_public_path__ + "media/images/tutorial_body_pc3-02-19b36f4fc8c02a2db99bd9896696e12b.png";